/* tslint:disable:max-line-length */
import { colors } from '@mm/utils';
import classNames from 'classnames';
import React from 'react';
import { IconTypeProps } from '../types';

export const NotificationsIcon = ({
  className,
  style,
  color,
  onClick,
}: IconTypeProps) => {
  const fill = color || colors.palePurple;
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M17.5 3H17C16.7237 3 16.5 3.19179 16.5 3.42857V3.77518L1.4775 6.76098C1.42531 6.57214 1.23625 6.42857 1 6.42857H0.5C0.22375 6.42857 0 6.62036 0 6.85714V11.1429C0 11.3796 0.22375 11.5714 0.5 11.5714H1C1.23625 11.5714 1.42531 11.4279 1.4775 11.239L5.07156 11.9534C5.035 12.1082 5.00031 12.2641 5.00031 12.4286C5.00031 13.8487 6.34344 15 8.00031 15C9.38125 15 10.5312 14.1967 10.8778 13.1073L16.5 14.2248V14.5714C16.5 14.8082 16.7237 15 17 15H17.5C17.7763 15 18 14.8082 18 14.5714V3.42857C18 3.19179 17.7763 3 17.5 3ZM8 13.7143C7.17281 13.7143 6.5 13.1376 6.5 12.4286C6.5 12.3637 6.52812 12.307 6.53906 12.2451L9.42188 12.818C9.22812 13.3358 8.66781 13.7143 8 13.7143ZM1.5 9.92411V8.07589L16.5 5.09437V12.9054L1.5 9.92411Z"
        fill={fill}
      />
    </svg>
  );
};
